// extracted by mini-css-extract-plugin
export default {"container":"PackOptionsTooltip_container__SXIaV","packOptionButton":"PackOptionsTooltip_packOptionButton__B1WCg","mock":"PackOptionsTooltip_mock__Erc6D"};